import { render, staticRenderFns } from "./TimelineSkeleton.vue?vue&type=template&id=4f965e9a&scoped=true&lang=pug&"
import script from "./TimelineSkeleton.vue?vue&type=script&lang=js&"
export * from "./TimelineSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TimelineSkeleton.vue?vue&type=style&index=0&id=4f965e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f965e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/tmp/7924dce7/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VSlideYTransition } from 'vuetify/lib'
installComponents(component, {VFlex,VSlideYTransition})
